
import { Offset } from '@/models/Offset';

export class TaxesFilter {
  offset = new Offset()
  year = 0
}
